'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import { createContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { CrmSuiteCards } from 'pricing-pages-unified-ui/constants/MerchCardsToShow';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import { SuiteTile } from './SuiteTile';
import debounce from 'pricing-pages-unified-ui/utils/wtDebounce';
import FormattedMessage from 'I18n/components/FormattedMessage';
import partial from 'transmute/partial';
import { borderStyle, StyledCardGrid } from '../../common/MerchCardSharedComponents';
const SelectorButtonWrapper = styled.div.withConfig({
  displayName: "SuiteTiles__SelectorButtonWrapper",
  componentId: "orrbu5-0"
})(["display:flex;width:80%;margin:0 auto;", ""], breakpoint.phoneLarge(_t || (_t = _`
    flex-direction: column;
  `)));
const SelectorButton = styled.button.withConfig({
  displayName: "SuiteTiles__SelectorButton",
  componentId: "orrbu5-1"
})(["font-size:0.75rem;padding:calc(1rem + 1px) 2rem;background:#fff;flex-grow:1;flex-basis:33%;border:1px solid #7fd1de;transition:background-color 0.3s;&:first-child{margin-right:-1px;border-radius:3px 0 0 3px;}&:last-child{margin-left:-1px;border-radius:0 3px 3px 0;}&:hover{background-color:#e5f5f8;}&.active{font-weight:500;border-width:2px;border-color:#00a4bd;background-color:#e5f5f8;}", ""], breakpoint.phoneLarge(_t2 || (_t2 = _`
    &:first-child {
      margin-bottom: -1px;
      margin-right: 0;
      border-radius: 3px 3px 0 0;
    }
    &:last-child {
      margin-top: -1px;
      margin-left: 0;
      border-radius: 0 0 3px 3px;
    }
  `)));

const MobileSelectorButton = ({
  productLevel,
  onClick,
  active
}) => {
  return /*#__PURE__*/_jsx(SelectorButton, {
    onClick: onClick,
    className: active ? 'active' : '',
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricingPage.pages.crmSuite.tiers.${productLevel.toLowerCase()}.title`
    })
  });
};

const isWidthMobile = width => width <= 1024;

export const IsMobileContext = /*#__PURE__*/createContext(isWidthMobile(window.innerWidth));
export const SuiteTiles = () => {
  const [isMobile, setIsMobile] = useState(isWidthMobile(window.innerWidth));
  const [selectedMobileProductLevel, setSelectedMobileProductLevel] = useState(CrmSuiteCards[0]);
  const productLevelsToShow = isMobile ? [selectedMobileProductLevel] : CrmSuiteCards;
  useEffect(() => {
    const resizeWindow = debounce(() => {
      setIsMobile(isWidthMobile(window.innerWidth));
    }, 250);
    window.addEventListener('resize', resizeWindow);
    return () => window.removeEventListener('resize', resizeWindow);
  }, []);
  const suiteCardComponents = productLevelsToShow.map((productLevel, index) => {
    const commonStyles = {
      msGridColumn: index + 1,
      // IE
      gridColumnStart: index + 1,
      paddingLeft: 32,
      paddingRight: 32,
      borderRight: index < productLevelsToShow.length - 1 ? borderStyle : 'none'
    };
    return /*#__PURE__*/_jsx(SuiteTile, {
      productLevel: productLevel,
      commonStyles: commonStyles
    }, productLevel);
  });
  return /*#__PURE__*/_jsx(IsMobileContext.Provider, {
    value: isMobile,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex-column align-center justify-center",
      children: [isMobile && /*#__PURE__*/_jsx(SelectorButtonWrapper, {
        children: CrmSuiteCards.map(productLevel => /*#__PURE__*/_jsx(MobileSelectorButton, {
          productLevel: productLevel,
          onClick: partial(setSelectedMobileProductLevel, productLevel),
          active: selectedMobileProductLevel === productLevel
        }, productLevel))
      }), /*#__PURE__*/_jsx(StyledCardGrid, {
        columns: isMobile ? 1 : CrmSuiteCards.length,
        isMobile: isMobile,
        children: suiteCardComponents
      })]
    })
  });
};